import * as React from 'react';

// 24x24 line icons, stroke = currentColor. Shared by gh-usp and the checkout payment sections.
const ICON_PATHS: Record<string, string> = {
    truck:
        '<rect x="1" y="6" width="14" height="10"/><path d="M15 9h4l3 3v4h-7z"/><circle cx="6" cy="18" r="2"/><circle cx="18" cy="18" r="2"/>',
    return: '<path d="M4 8h12a5 5 0 010 10H9"/><path d="M8 4L4 8l4 4"/>',
    shield: '<path d="M12 2l8 3v6c0 5-3.5 9-8 11-4.5-2-8-6-8-11V5z"/><path d="M8.5 12l2.5 2.5 4.5-5"/>',
    store:
        '<path d="M3 9l1.5-5h15L21 9"/><path d="M3 9a3 3 0 006 0 3 3 0 006 0 3 3 0 006 0"/><path d="M5 11v9h14v-9"/><path d="M10 20v-5h4v5"/>',
    gift:
        '<rect x="3" y="8" width="18" height="4"/><path d="M5 12v9h14v-9"/><path d="M12 8v13"/><path d="M12 8c-2-3-6-3-6-1s3 1 6 1c3 0 6 1 6-1s-4-2-6 1"/>',
    diamond: '<path d="M6 3h12l4 6-10 12L2 9z"/><path d="M2 9h20"/><path d="M9 3l3 6 3-6"/><path d="M6 9l6 12 6-12"/>',
    chat: '<path d="M4 4h16v11H9l-5 4z"/>',
    star: '<path d="M12 2.5l2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 17.4 6.1 20.5l1.2-6.5L2.5 9.4l6.6-.9z"/>',
    ring: '<circle cx="12" cy="14" r="7"/><circle cx="12" cy="14" r="4.5"/><path d="M9 6l3-3 3 3-3 2z"/>',
    card: '<rect x="2" y="5" width="20" height="14"/><path d="M2 10h20"/><path d="M6 15h4"/>'
};

export const DEFAULT_LINE_ICON = 'star';

export const GhLineIcon: React.FC<{ name?: string; className?: string }> = ({ name, className }) => {
    const paths = (name && ICON_PATHS[name]) || ICON_PATHS[DEFAULT_LINE_ICON];
    return (
        <svg
            className={className}
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth={1.25}
            strokeLinecap='round'
            strokeLinejoin='round'
            aria-hidden='true'
            focusable='false'
            dangerouslySetInnerHTML={{ __html: paths }}
        />
    );
};
